<template>
    <empty-settings 
        model="i Ruoli"
    ></empty-settings>
</template>

<script>
    import EmptySettings from '@/components/common/EmptySettings'

    export default {
        name: 'roles-settings',
        components: {
            EmptySettings
        },
        props: {},
        data() {
            return {

            }
        },
        mounted() {
            this.$store.commit('endProgress')
        }
    }
</script>